import type {SkeletonBrickTheme} from '@Components/skeleton-brick';
import type {AiPromptBoxAttachments} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import type {ChatMessage, ModelMessage, RequestConfig, TextPartPurpose} from '@Components/ai-chat-window/ai-chat-window.types';

export const MAX_CHAT_IMAGE_DIMENSION = 400;
export const MAX_CHAT_IMAGE_WIDTH_SMALL_SCREEN = 190;
export const MAX_CHAT_IMAGE_HEIGHT_SMALL_SCREEN = 275;

export interface GeneratedImagePartActionsProps {
  onDownload: () => void;
  onOpenPosterInEditor: () => Promise<void>;
  onShareDesign: () => Promise<void>;
  canWrite: boolean;
  onRegenerate: (prompt?: string, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => void;
  onGenerate: (prompt: string, promptAttachments?: AiPromptBoxAttachments, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => Promise<void>;
}

export interface GeneratedImageProps {
  src: string;
  alt: string;
  onImageClick?: () => void;
  onReattach?: VoidFunction;
  className?: string;
  width: number;
  height: number;
  hashedId: string;
  chatId: string;
  skeltonLoaderTheme?: SkeletonBrickTheme;
  showFirstImageGenerationDelight?: boolean;
  isMobile?: boolean;
  generatedImagePartActionsProps: GeneratedImagePartActionsProps;
  isLastMessage: boolean;
  message: ModelMessage;
  messages: Record<string, ChatMessage>;
  isWaitingForImageGeneratedEvent?: boolean;
  isSkeletonOnly?: boolean;
  isMessageStreaming?: boolean;
}

export interface Dimensions {
  width: number;
  height: number;
}
